var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_300_6929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0V56.28H56V0H0ZM9.34541 28.9287V15.0832C15.4791 15.0832 21.0815 17.3767 25.3437 21.1505C21.975 24.7666 19.5481 29.2806 18.4614 34.2922C16.6744 31.1008 13.2695 28.9287 9.34541 28.9287ZM46.6425 30.1301C46.3286 30.1058 46.0147 30.0815 45.6887 30.0815C40.0862 30.0815 35.5343 34.6441 35.5343 40.2867C35.5343 40.59 35.5464 40.8934 35.5705 41.1968L20.9125 41.1968C20.9004 40.8934 20.9004 40.59 20.9004 40.2867C20.9004 26.5261 31.9966 15.3623 45.7007 15.3623C46.0267 15.3623 46.3407 15.3745 46.6546 15.3866V30.1301H46.6425Z",
    fill: "#5720CD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_300_6929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56.28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.df15f72a441d87e2f0a25243c9240962.svg";
export { ForwardRef as ReactComponent };